import api from '../api';

export const categoriesFetchSuccess = (categories) => {
    return {
        type: 'CATEGORIES_FETCH_SUCCESS',
        categories
    };
};

export function loadCategories() {
    return (dispatch) => {
        dispatch(categoriesFetchSuccess(api.getCategories()));
    };
}

export function getCategory(category_slug, state) {
    let category = {
        name: "category"
    };
    if(state.categories.length > 0) {

        category = state.categories.reduce(function(category, item) {
            return item.slug == category_slug ? item : category;
        }, category);

    }

    return category;
}




// WEBPACK FOOTER //
// ./src/actions/categoryActions.js